import { render } from "./TeachersTable.vue?vue&type=template&id=c1219d74&scoped=true"
import script from "./TeachersTable.vue?vue&type=script&lang=js"
export * from "./TeachersTable.vue?vue&type=script&lang=js"

import "./TeachersTable.vue?vue&type=style&index=0&id=c1219d74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1219d74"]])

export default __exports__